import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Confirm from '../confirm/Confirm';
import './View.css';
import EmailService from '../../service/EmailService';

class SendEmailView extends React.Component {
  constructor(props) {
    super(props);

    this.addEmail = this.addEmail.bind(this);
    this.removeEmail = this.removeEmail.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
    this.onCustomerIdChange = this.onCustomerIdChange.bind(this);
    this.onEmailIdChange = this.onEmailIdChange.bind(this);

    this.state = {
      emailId: '',
      open: false,
    };
  }

  componentDidMount() {
    const { requestedState, } = this.props;
    if (requestedState) {
      this.setState({
        emailId: requestedState.emailId,
      });
    }
  }

  onEmailChange(event, index) {
    const { inputs = [], } = this.state;
    const newInputs = inputs.slice();
    newInputs[index][0] = event.target.value;
    this.setState({
      inputs: newInputs,
    });
  }

  onCustomerIdChange(event, index) {
    const { inputs = [], } = this.state;
    const newInputs = inputs.slice();
    newInputs[index][1] = event.target.value;
    this.setState({
      inputs: newInputs,
    });
  }

  onEmailIdChange(event) {
    this.setState({ emailId: event.target.value, });
  }

  handleClickOpen = () => {
    this.setState({ open: true, });
  };

  handleClose = () => {
    this.setState({ open: false, });
  };

  sendEmail = ({ inputs, emailId, }) => {
    const regexGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    this.setState({ isLoading: true, });
    if (!regexGuid.test(emailId)) {
      console.log('not valid');
    } else {
      EmailService.resendEmail(emailId, inputs)
        .catch((err) => {
          throw Error(err);
        })
        .finally(() => {
          this.handleClose();
          this.setState({ isLoading: false, inputs: [], emailId: '', });
        });
    }
  };

  addEmail() {
    const { inputs = [], } = this.state;

    this.setState({
      inputs: inputs.concat([ [ '', '', ], ]),
    });
  }

  removeEmail(passedIndex) {
    const { inputs = [], } = this.state;
    const filteredInput = inputs.filter((_input, index) => index !== passedIndex);
    this.setState({
      inputs: filteredInput,
    });
  }

  render() {
    const {
      inputs = [], emailId, isLoading, open,
    } = this.state;
    const isEmailPresent = (input) => input[0];
    const shouldDisableSubmit = inputs.length !== 0 && !(inputs.every(isEmailPresent));

    return (
      <div className="content">
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Email Id:</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter an email id"
            value={emailId}
            onChange={event => this.onEmailIdChange(event)}
          />
        </Form.Group>
        <br />
        <div className="basic-input-content">
          <Row className="mt-3">
            <Col>
              <Button variant="primary" onClick={() => this.addEmail()}>
                Add Email
              </Button>
              <Button variant="success" className="ms-2" onClick={this.handleClickOpen} disabled={shouldDisableSubmit}>
                Submit
              </Button>
              <Confirm
                isLoading={isLoading}
                title="Send Email Confirmation"
                content="Are you sure you want to send this email?"
                open={open}
                onClose={this.handleClose}
                onYes={() => this.sendEmail({ inputs, emailId, })}
                onNo={this.handleClose}
              />

              {inputs.map((input, index) => {
                const emailAddress = `${input.key} - emailAddress`;
                const customerId = `${input.key} - customerID`;
                const keyIndex = index;

                return (
                  <div key={keyIndex}>
                    <Form.Label className="mt-2" key={`${emailAddress} ${keyIndex}`}>
                      Recipient
                      {index + 1}
                      :
                      <br />
                      Email address is a required field for emails to send.
                      Customer Id is highly suggested for reporting but not required.
                    </Form.Label>
                    <Form.Control
                      id={emailAddress}
                      key={`Control ${emailAddress} ${keyIndex}`}
                      type="text"
                      placeholder="Enter an email address (required)"
                      value={input[0]}
                      onChange={event => this.onEmailChange(event, index)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter an email address.
                    </Form.Control.Feedback>
                    <Form.Control
                      id={customerId}
                      key={`Control ${customerId} ${keyIndex}`}
                      type="text"
                      placeholder="Enter a customer id"
                      value={input[1]}
                      onChange={event => this.onCustomerIdChange(event, index)}
                    />
                    <Button variant="dark" className="mt-2" onClick={() => this.removeEmail(index)}>
                      Remove
                    </Button>
                    <hr />
                  </div>
                );
              })}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

SendEmailView.defaultProps = {
  requestedState: undefined,
};

SendEmailView.propTypes = {
  requestedState: PropTypes.instanceOf(Object),
};

export default SendEmailView;
